import { Flex } from "@chakra-ui/react"
import { LuBookmark, LuBookmarkCheck } from "react-icons/lu"
import { NAVY } from "./constants"

// Navy pill shown under a list of session cards; styled to match the Show/Hide
// Sessions toggle and the card actions (InlineSessionCard).
export default function SaveAllButton({ sessionIds, sessionActions }) {
    const allSaved = sessionIds.every(id => sessionActions.sessionsById?.[id]?.saved)
    return (
        <Flex
            as="button"
            type="button"
            align="center"
            gap="6px"
            w="fit-content"
            px="14px"
            py="7px"
            mt="4px"
            borderRadius="full"
            cursor={allSaved ? "default" : "pointer"}
            bg={NAVY}
            color="#fff"
            fontSize="12px"
            fontWeight="500"
            lineHeight={1}
            transition="background 0.15s ease"
            _hover={allSaved ? {} : { bg: "#152E58" }}
            aria-disabled={allSaved}
            onClick={() => !allSaved && sessionActions.onSaveAll(sessionIds)}
        >
            {allSaved ? <LuBookmarkCheck size={13} /> : <LuBookmark size={13} />}
            {allSaved ? "All sessions saved" : "Add all sessions to my schedule"}
        </Flex>
    )
}
